/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ControlcenterMelcoModelsError,
    ControlcenterMelcoModelsErrorFromJSON,
    ControlcenterMelcoModelsErrorToJSON,
    ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsPlatform,
    ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsPlatformFromJSON,
    ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsPlatformToJSON,
} from '../models';

/**
 * 
 */
export class PlatformsApi extends runtime.BaseAPI {

    /**
     */
    async platformsListRaw(): Promise<runtime.ApiResponse<ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsPlatform>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/platforms`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsPlatformFromJSON(jsonValue));
    }

    /**
     */
    async platformsList(): Promise<ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsPlatform> {
        const response = await this.platformsListRaw();
        return await response.value();
    }

}
